import { createAction, props } from "@ngrx/store";
import { PermissionCard } from "./auction.reducers";

export const saveAcceptTermsOfuse = createAction(
  "[Edital] save",
  props<{ acceptTermsOfuse: boolean }>()
);

export const saveCanBid = createAction(
  "[Auction canBid] save",
  props<{ canBid: boolean }>()
);

export const saveAllState = createAction(
  "[Auction] saveAll",
  props<{
    acceptTermsOfuse: boolean;
    auctionKey: string;
    canBid: boolean;
    edict: string;
    isLiveTrading: boolean;
    permissionCard: PermissionCard;
  }>()
);

export const saveEdict = createAction("[Auction] saveEdict");
export const saveAuctionKey = createAction("[Auction] saveAuctionKey");
